import React from 'react';
import { PapiUser } from '@wix/da-papi-types';
import cn from 'classnames';
import PromoBadgeWithTooltip from '../../PromoBadgeWithTooltip';

import s from './AvatarIndicators.scss';

export interface Props {
  user?: PapiUser;
  className?: string;
  topRight?: React.ReactNode | 'tierSubscribed';
  topLeft?: React.ReactNode;
  bottomRight?: React.ReactNode;
  bottomLeft?: React.ReactNode;
}

const IndicatorWrapper: React.FC<React.PropsWithChildren<Props>> = ({
  user,
  topLeft,
  topRight,
  bottomLeft,
  bottomRight,
  className,
  children,
}) => {
  return (
    <div className={cn(s['root'], className)}>
      {topLeft && <div className={s['top-left']}>{topLeft}</div>}
      {topRight && (
        <div className={s['top-right']}>
          {topRight === 'tierSubscribed' ? (
            <>{user?.isSubscribed && <PromoBadgeWithTooltip badgeType="tier" size={16} />}</>
          ) : (
            topRight
          )}
        </div>
      )}
      {bottomLeft && <div className={s['bottom-left']}>{bottomLeft}</div>}
      {bottomRight && <div className={s['bottom-right']}>{bottomRight}</div>}
      {children}
    </div>
  );
};
IndicatorWrapper.displayName = 'IndicatorWrapper';

export default IndicatorWrapper;
